<template>
    <div>
        <div v-if="activeTab == 'understanding-your-tyres'">
            <understanding-your-tyres></understanding-your-tyres>
        </div>
        <div v-else-if="activeTab == 'tyre-labelling'">
            <tyre-labelling></tyre-labelling>
        </div>
        <div v-else-if="activeTab == 'are-your-tyres-legal'">
            <are-your-tyres-legal></are-your-tyres-legal>
        </div>
        <div v-else-if="activeTab == 'all-inclusive'">
            <all-inclusive></all-inclusive>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['activeTab']
    }
</script>

<style lang="scss" scoped>

</style>